import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, KeepAlive as _KeepAlive, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-118ae233"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-layout" }
const _hoisted_2 = { style: {"min-height":"calc(100vh - 214px)"} }
const _hoisted_3 = {
  key: 1,
  style: {"height":"100px"}
}

import { ref } from "vue";
import Header from "@/components/Header.vue"; // 头部
import Footer from "@/components/footer.vue"; // 尾部
import { useRoute } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const hideRoutes = ref(['/my/home', '/my/works', '/my/earnings', '/my/payment', '/my/download', '/my/collect', '/my/setting', '/publish', '/my/nojoin','/search/mobile'])

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header),
    _createElementVNode("main", _hoisted_2, [
      (_openBlock(), _createBlock(_KeepAlive, null, [
        _createVNode(_component_router_view)
      ], 1024))
    ]),
    (!hideRoutes.value.includes(_unref(route).path))
      ? (_openBlock(), _createBlock(Footer, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_3))
  ]))
}
}

})